import { RunModType } from "./RunModeContext";

const BASE_URL = process.env.REACT_APP_BASE_URL

const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

type ResponseTypes = {
    message: string;
    httpStatus: string;
    data?: any;
    errorCode?: number;
    errorMessage?: number;
    access_token?: string
}

export type RequestGetUserRunMode = {
    runMode: RunModType;
}

export type ResponseGetUserRunMode = {
    mode: RunModType;
}

export const APIGetUserRunMode = async (): Promise<{ status: boolean; data: ResponseGetUserRunMode | null, message: string }> => {
    const URL = `${BASE_URL}/identity_manager/api/v1/getUserRunMode`

    const HEADER: RequestInit = {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`
        }
    }

    const response = await fetch(URL, HEADER)
    const responseData = await response.json() as ResponseTypes

    if (response.ok)
    {
        return { status: true, data: responseData.data as ResponseGetUserRunMode | null, message: responseData.message }
    }
    return { status: false, data: responseData.data as ResponseGetUserRunMode | null, message: responseData.message }
}


export const APISetupUserRunMode = async (body: RequestGetUserRunMode): Promise<{ status: boolean; data: ResponseGetUserRunMode | null, message: string }> => {
    const URL = `${BASE_URL}/identity_manager/api/v1/setupUserRunMode`

    const HEADER: RequestInit = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`
        },
        body: JSON.stringify(body)
    }

    const response = await fetch(URL, HEADER)
    const responseData = await response.json() as ResponseTypes

    if (response.ok)
    {
        return { status: true, data: responseData.data as ResponseGetUserRunMode | null, message: responseData.message }
    }
    return { status: false, data: responseData.data as ResponseGetUserRunMode | null, message: responseData.message }
}